// growthos/warchest-frontend/react-app/src/pages/scenario-builder/v3/components/DeleteCommentModal/DeleteCommentModal.tsx
import React from "react";

import { OutlinedButton, PrimaryButton } from "@/Components/v2/atoms/Button";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@/Components/v2/atoms/Dialog";
import { Typography } from "@/Components/v2/atoms/Typography";

interface DeleteCommentModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteCommentModal: React.FC<DeleteCommentModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Delete Comment</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to delete this comment? This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <OutlinedButton onClick={onClose}>Cancel</OutlinedButton>
        <PrimaryButton onClick={onConfirm} color="error">
          Delete
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};
